import React from 'react';
import ReactDOM from 'react-dom';
import { hashHistory, Router, Route } from 'react-router';
import { syncHistoryWithStore } from 'react-router-redux';
import { Provider as ReduxProvider } from 'react-redux';
import { hydratedData } from 'services/hydrated-data';
import { setSiteBasedUrls } from 'services/site-based-urls';
import { appStatus } from 'services/app-status';

import WixSDK from 'shared/utils/wix-sdk';

import LayoutSwitcher from 'widget/layouts/layout-switcher';

import applicationNames from 'shared/constants/application-names';
import { setupEnv } from 'shared/env/setup-env';
import { addSingleMeasurement } from 'shared/utils/performance';
import configureStore from 'widget/redux/configure-store';
import { setupSentryForDesktop } from '../loggers/sentry';

setupSentryForDesktop();
addSingleMeasurement('appRenderStart');
setupEnv();

const store = configureStore({
  configuration: {
    applicationName: applicationNames.WIDGET,
  },
});
const history = syncHistoryWithStore(hashHistory, store);

function render() {
  setSiteBasedUrls();
  WixSDK.Performance.applicationLoadingStep(2, 'rendering-start');
  appStatus.init();

  ReactDOM.render(
    <ReduxProvider store={store}>
      <Router history={history}>
        <Route path="/" component={LayoutSwitcher} />
      </Router>
    </ReduxProvider>,
    document.getElementById('root'),
  );
}

hydratedData.onReady(render);
